
import './App.css';
import React, { useState  } from 'react';
import ChatUI from './Main.jsx';
import Thank from './Thank.jsx';


function App() {

  const [showSecondPage, setShowSecondPage] = useState(false); // 控制页面显示状态

  // 接收第一个页面的请求完成结果并更新显示状态
  const handleRequestComplete = () => {
    setShowSecondPage(true); // 切换到第二个页面
  };

  return (
    <div className="App">
      <header className="App-header">
      {showSecondPage ? (
        <Thank />
      ) : (
        <ChatUI onRequestComplete={handleRequestComplete} /> // 传递回调函数给第一个页面
      )}

      </header>
    </div>
  );
}

export default App;
